import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useGTMDispatch } from '@elgorditosalsero/react-gtm-hook';

const PageViewTracker = () => {
  const location = useLocation();
  const sendDataToGTM = useGTMDispatch();

  useEffect(() => {
    // トラッキングする条件を指定
    if (location.pathname.startsWith('/register')) {
      sendDataToGTM({
        event: 'page_view',
        page_location: window.location.href,
        page_path: location.pathname + location.search,
        page_title: document.title
      });
    }
  }, [location]);
  return null;
};

export default PageViewTracker;
